<template>
    <div  class="form-page">
        <my-form v-model="form" readonly table>
            <el-form-item label="公告名称" prop="ggname" class="table-full-row">
                {{form.ggname||'-'}}
            </el-form-item>      
            <el-form-item label="关联标段" prop="bdnames" class="table-full-row">
                {{form.bdnames||'-'}}
            </el-form-item>    
            <!-- <el-form-item label="公告性质" prop="ggxzname" class="table-full-row">
                {{form.ggxzname||'-'}}
            </el-form-item>  
            <el-form-item label="公告类型" prop="gglxname" class="table-full-row">
                {{form.gglxname||'-'}}
            </el-form-item>   -->
            <el-form-item label="公告发布时间" prop="ggfbtime" class="table-full-row">
                {{form.ggfbtime||'-'}}
            </el-form-item>  
            <el-form-item label="招标文件获取时间" v-if="form.is_wjhqsj==='0'" prop="wjhqtime" class="table-full-row">
                {{form.wjhqtime||'-'}}
            </el-form-item>  
            <el-form-item label="公告结束时间" prop="ggendtime" class="table-full-row">
                {{form.ggendtime||'-'}}
            </el-form-item>  
            <el-form-item label="响应文件递交截止时间" prop="xywjdjjzsj" class="table-full-row">
                {{form.xywjdjjzsj||'-'}}
            </el-form-item> 
            <el-form-item label="响应文件递交方法"  class="table-full-row">
                <div v-if="form.xywjdjff==='1'">网上递交</div>
                <div v-if="form.xywjdjff==='2'">线下递交</div>               
            </el-form-item> 
            <el-form-item label="文件获取时间范围" class="table-full-row">
                <div v-if="form.wjhqsjfw==='0'">投标人只能在公告发布期内下载文件</div>
                <div v-if="form.wjhqsjfw==='1'">投标人可以在任意时间下载招标文件</div>
            </el-form-item> 
            <el-form-item label="公告内容文本" prop="ggcontent" class="table-full-row">
                <div v-html="form.ggcontent"></div>
            </el-form-item> 
        </my-form>
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
export default {
    mixins: [LIST_PAGE_MIXIN],
    data() {
        return{
            form:{},
            zbproname:''
        }
    },
    computed: {
        
    },
    watch: {

    },
    methods: {


    },
    created() {
        
    },
    mounted() {
        var that=this;
        if(this.$route.query.ggcode!=undefined){
            that.$get(`${this.getGetters('bidUrl')}/FangAn/Zbgg/xingtai/detail2.json`,{id:this.$route.query.ggcode,procode:this.$route.query.procode}, (data, res) => {
                that.form=data.model;
            });
        }
    }
}
</script>

<style scoped lang="scss">

</style>
